export const manifest = {
  screens: {
    scr_yve7mx: { name: "Dashboard", route: "/" },
    scr_l00df6: { name: "Event Log", route: "/events", position: {"x":1560,"y":3800} },
    scr_hfpa1f: { name: "Prospect Database", route: "/prospects", position: {"x":160,"y":1820} },
    scr_0sa9dc: { name: "Manual DNC", route: "/manual-dnc", position: {"x":1560,"y":1820} },
    scr_nvro2s: { name: "Refresh Jobs", route: "/refresh-jobs", position: {"x":160,"y":3800} },
    scr_gqwnvv: { name: "Reassignment", route: "/reassignment", position: {"x":2960,"y":1820} },
    scr_pnuqea: { name: "Connections", route: "/connections", position: {"x":160,"y":5780} },
    scr_vltw7z: { name: "Accounts", route: "/accounts", position: {"x":1560,"y":5780} },
    scr_nmivaf: { name: "System Monitoring", route: "/monitoring", position: {"x":2960,"y":3800} },
  },
  sections: {
    sec_28948c: { name: "Prospect Management", x: 0, y: 1600, width: 4320, height: 1180 },
    sec_6kws8x: { name: "Operations & Monitoring", x: 0, y: 3580, width: 4320, height: 1180 },
    sec_su9mhl: { name: "System Configuration", x: 0, y: 5560, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "screen", id: "scr_yve7mx" },
    { kind: "section", id: "sec_28948c", children: [
      { kind: "screen", id: "scr_hfpa1f" },
      { kind: "screen", id: "scr_0sa9dc" },
      { kind: "screen", id: "scr_gqwnvv" },
    ] },
    { kind: "section", id: "sec_6kws8x", children: [
      { kind: "screen", id: "scr_nvro2s" },
      { kind: "screen", id: "scr_l00df6" },
      { kind: "screen", id: "scr_nmivaf" },
    ] },
    { kind: "section", id: "sec_su9mhl", children: [
      { kind: "screen", id: "scr_pnuqea" },
      { kind: "screen", id: "scr_vltw7z" },
    ] },
  ],
}
